import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { BreedState } from '../types'
import { Getters, getterTypes as types } from './getter-types'

export const getters: GetterTree<BreedState, RootState> & Getters = {
	[types.GET_INDEX_BREED]: (state) => (breedId) => {
		return state.breeds.data.findIndex((breed) => breed.id === breedId)
	},
}

export default getters
